var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:'search-filter-label ' + _vm.classes},[_vm._v(_vm._s(_vm.title)+" "),_c('img',{attrs:{"src":require("@/assets/imgs/svgs/close.svg"),"alt":""},on:{"click":_vm.onClickCross}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f44f5a48","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Search/helper/SearchFilterLabel.vue
// module id = 1138
// module chunks = 1